module.exports = __webpack_public_path__ + "img/wide.ad7471df.jpg";